import { t } from 'ttag'

import { appendSearchResults, initSearchResults } from './search'

import * as h2Api from '../h2Api'

export const COLLEGE_LOADED = 'COLLEGE_LOADED'
export const CLEAR_SELECTED = 'COLLEGE_CLEAR_SELECTED'
export const COLLEGE_SELECT_LOADED = 'COLLEGE_SELECT_LOADED'
export const COLLEGE_LOADED_LOG = 'COLLEGE_LOADED_LOG'
export const RATE_COLLEGE = 'RATE_COLLEGE'
export const COLLEGE_CREATE_PLAN = 'COLLEGE_CREATE_PLAN'
export const COLLEGES_LOAD_COUNTS = 'COLLEGES_LOAD_COUNTS'

export const COLLEGE_COMPARISON = 'COLLEGE_COMPARISON'

export const SELECT_COLLEGE_FOR_COMPARISON = 'SELECT_COLLEGE_FOR_COMPARISON'
export const REMOVE_COLLEGE_FOR_COMPARISON = 'REMOVE_COLLEGE_FOR_COMPARISON'
export const COLLEGE_COMPARISON_SET_ERROR = 'COLLEGE_COMPARISON_SET_ERROR'
export const CLEAR_COLLEGE_COMPARISON = 'CLEAR_COLLEGE_COMPARISON'

export const ALL_COLLEGE_LISTING = 'ALL_COLLEGE_LISTING'
export const ADD_COLLEGE_LISTING = 'ADD_COLLEGE_LISTING'

export const loadAllCollegesListing = filters => dispatch => {
  return dispatch(
    h2Api.post(`/api/v1/colleges/list`, { filters })({ type: ALL_COLLEGE_LISTING })
  ).then(v => {
    //console.log(v)
    dispatch(initSearchResults(v.results))

    return v
  })
}

export const loadSubsequentCollegesListing = filters => (
  startIdx,
  endIdx
) => dispatch => {
  const updatedJson = {
    filters,
    start: startIdx,
    end: endIdx
  }

  return dispatch(
    h2Api.post(`/api/v1/colleges/list`, updatedJson)({ type: ADD_COLLEGE_LISTING })
  ).then(v => {
    console.log('APPENDING')
    dispatch(appendSearchResults(v.results))
  })
}

export const selectForComparison = id => (dispatch, getState) => {
  const comparisons = getState().college.comparison.selectedInstitutions.length

  console.log(id)

  if (comparisons == 4) {
    alert(t`You already have four items selected`)

    return false
  }

  return Promise.resolve(dispatch({ type: SELECT_COLLEGE_FOR_COMPARISON, id }))
}

export const removeForComparison = id => dispatch => {
  return Promise.resolve(dispatch({ type: REMOVE_COLLEGE_FOR_COMPARISON, id }))
}

export const compareInstitutions = institutions => dispatch => {
  const items = typeof institutions === 'string' ? [institutions] : institutions

  console.log(items, institutions)

  if (!items) {
    return Promise.resolve(
      dispatch({
        type: COLLEGE_COMPARISON_SET_ERROR,
        error: t`No institution specified for comparison`
      })
    )
  }

  dispatch({
    type: COLLEGE_COMPARISON_SET_ERROR,
    error: null
  })

  return dispatch(
    h2Api.post('/colleges/compare', { institutionId: items })({
      type: COLLEGE_COMPARISON
    })
  )
}

export const clearInstitutionComparison = () => dispatch => {
  return Promise.resolve(dispatch({ type: CLEAR_COLLEGE_COMPARISON }))
}

export const loadCollegeCounts = () => {
  return h2Api.get('/api/v1/colleges/count')({ type: COLLEGES_LOAD_COUNTS })
}

export const loadCollege = occupationId => (dispatch, getState) => {
  dispatch({ type: CLEAR_SELECTED })

  return dispatch(
    h2Api.get(`/colleges/profile/${occupationId}`)({ type: COLLEGE_LOADED })
  )
}

export const toggleCollegeFlag = institutionId => dispatch => {
  return dispatch(
    h2Api.put(
      `/user/flag/college/${institutionId}`,
      {}
    )({
      type: RATE_COLLEGE,
      id: institutionId
    })
  )
}

export const createPlan = institutionId => dispatch => {
  return dispatch(
    h2Api.post(
      `/colleges/plan/${institutionId}`,
      {}
    )({
      type: COLLEGE_CREATE_PLAN
    })
  )
}

export const rateCollege = (institutionId, ratingType) => dispatch => {
  //console.log("RATING", occupation, ratingType)
  return dispatch(
    h2Api.put(`/user/rate/college/${institutionId}`, {
      rating: ratingType
    })({ type: RATE_COLLEGE, id: institutionId })
  )
}
